import { conf } from './conf2';

class Config {

	constructor() {
		this.conf = conf;

		this.processEnvironment();

	}

	processEnvironment() {



		// Browser
		// if (typeof(window) !== "undefined") {
		// 	//console.log("dectect browser");
		// 	this.conf.LIVENET = window.env.LIVENET;
		// 	this.conf.port = window.env.port;
		// 	this.conf.server =  window.env.server;
		// 	this.conf.stats = window.env.stats;
		// 	this.conf.livenetUrl = window.env.livenetUrl;
		// 	this.conf.testnetUrl = window.env.testnetUrl;
    //  this.conf.circulatingSupplyUrl: window.env.CIRCULATING_SUPPLY_URL;

		// // Server Side 
		// } else  {
		// 	//console.log("detected server side");

		// 	this.conf.LIVENET = process.env.LIVENET || this.conf.LIVENET;
		// 	this.conf.port = process.env.PORT || this.conf.port;
		// 	this.conf.server =  process.env.API_URL || this.conf.server;
		// 	this.conf.stats = process.env.STATS_API_URL || this.conf.stats;
		// 	this.conf.livenetUrl = process.env.LIVENET_URL || this.conf.livenetUrl;
		// 	this.conf.testnetUrl = process.env.TESTNET_URL || this.conf.testnetUrl;
    //  this.conf.circulatingSupplyUrl = process.env.CIRCULATING_SUPPLY_URL || this.conf.circulatingSupplyUrl;

		// }


		if (typeof this.conf.LIVENET !== "boolean") {
			this.conf.LIVENET = Boolean(parseInt(this.conf.LIVENET, 10));

		}
		this.conf.livenet = this.conf.LIVENET;

		//console.log(this.conf);

		//console.log("After: ", this.conf);

	}


}

/*
let apiUrl = 'http://localhost:3000'
if (process.env.NODE_ENV === 'production') {
  apiUrl = ''
}
export {
  apiUrl
}
*/
//let config = new Config();

//console.log(config.conf);
//console.log(process.env);


export default Config;



// WEBPACK FOOTER //
// ./src/Config.js